import { StateKey } from 'common/utils/flipState'
import { fetchPagedReviews } from 'common/services/review'
import {
  PagedReviews,
  ReviewContentClassType,
  ReviewPagingParams,
  ReviewSearchFeatureType,
  ReviewSearchSortType,
  ReviewType,
} from 'common/types/entities/api/review'
import { getReviewsSetLikes } from 'common/services/like'
import { ArrayUtils } from '@shopping/common'

const FETCH = 'review/pagedProductReview/FETCH'
const CHANGE_HELP_COUNT = 'review/pagedProductReview/CHANGE_HELP_COUNT'
const APPEND = 'review/pagedProductReview/APPEND'

const initialState: PagedReviews = {
  contents: [],
  page: 0,
  size: 0,
  totalElements: 0,
  totalPages: 0,
  loaded: false,
}

export interface PagedProductReviewParam {
  page: number
  pageSize: number
  curState: StateKey
  headers: any
  selectedSort: ReviewSearchSortType
  selectedFeature: ReviewSearchFeatureType
  selectedTopic: string
  originProductNo: string
  merchantNo: string
  isAppend?: boolean
}
export const fetchPagedProductReviews = ({
  page,
  pageSize,
  curState,
  headers,
  selectedSort,
  selectedFeature,
  selectedTopic,
  originProductNo,
  merchantNo,
  isAppend,
}: PagedProductReviewParam) => async dispatch => {
  let params: ReviewPagingParams = {
    page,
    pageSize,
    merchantNo,
    originProductNo,
    sortType: selectedSort,
  }
  if (selectedFeature === ReviewSearchFeatureType.BEST) {
    params = {
      ...params,
      bestReviewYn: true,
    }
  }
  if (selectedFeature === ReviewSearchFeatureType.PHOTO_VIDEO) {
    params = {
      ...params,
      reviewContentClassTypes: [ReviewContentClassType.PHOTO, ReviewContentClassType.VIDEO],
    }
  }
  if (selectedFeature === ReviewSearchFeatureType.AFTER_USE) {
    params = {
      ...params,
      reviewType: ReviewType.AFTER_USE,
    }
  }
  if (selectedTopic) {
    params = {
      ...params,
      topicCode: selectedTopic,
    }
  }
  const pagedReviews = await fetchPagedReviews(params, headers)
  if (!(pagedReviews && ArrayUtils.isNotEmpty(pagedReviews.contents))) {
    return dispatch({
      curState,
      pagedReviews,
      type: isAppend ? APPEND : FETCH,
    })
  }
  pagedReviews.contents = await getReviewsSetLikes(pagedReviews.contents, headers)
  if (selectedTopic) {
    pagedReviews.contents.forEach(review => {
      review.reviewTopics &&
        (review.reviewTopics = review.reviewTopics.filter(topic => topic.topicCode === selectedTopic))
    })
  } else {
    pagedReviews.contents.forEach(review => {
      review.reviewTopics = null
    })
  }
  dispatch({
    curState,
    pagedReviews,
    type: isAppend ? APPEND : FETCH,
  })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH:
      return {
        ...action.pagedReviews,
        loaded: true,
      }
    case APPEND:
      return {
        ...state,
        ...action.pagedReviews,
        contents: [...state.contents, ...action.pagedReviews.contents],
      }
    case CHANGE_HELP_COUNT:
      return {
        ...state,
        contents: action.contents,
      }
    default:
      return state
  }
}
export default reducer
